import { useLocale } from '@/i18n'

import { sharedEn, sharedDe, sharedFr } from './dictionaries/sections/shared'

const sharedDictionaries = { en: sharedEn, de: sharedDe, fr: sharedFr }

export type SharedDictionary = typeof sharedEn

export function useSharedTranslation(): SharedDictionary {
    const locale = useLocale()

    return sharedDictionaries[locale] ?? sharedEn
}

export function getSharedDictionary(locale?: string): SharedDictionary {
    if (locale === 'de') return sharedDe
    if (locale === 'fr') return sharedFr

    return sharedEn
}

// Splits a copy template on its `{name}` placeholder so the dynamic value can be rendered
// as its own styled element while each language keeps its natural word order.
export function splitAround(template: string, placeholder = '{name}'): [string, string] {
    const index = template.indexOf(placeholder)

    if (index === -1) return [template, '']

    return [template.slice(0, index), template.slice(index + placeholder.length)]
}
